import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpinnerAnim = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	className: "spinner-anim",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 18.2 18.2",
	style: { enableBackground: "new 0 0 18.2 18.2" },
	xmlSpace: "preserve",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			children: "\n	.st0{fill:#666666;}\n"
		}),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("g", {
				transform: "rotate(0 50 50)",
				children: /* @__PURE__ */ _jsx("path", {
					className: "st0",
					d: "M8.7,0h0.7c0.2,0,0.3,0.2,0.3,0.3v3.5c0,0.2-0.2,0.3-0.3,0.3H8.7C8.6,4.2,8.4,4,8.4,3.9V0.3 C8.4,0.2,8.6,0,8.7,0z ",
					children: /* @__PURE__ */ _jsx("animate", {
						accumulate: "none",
						additive: "replace",
						attributeName: "opacity",
						begin: "-0.9166666666666666s",
						calcMode: "linear",
						dur: "1s",
						fill: "remove",
						keyTimes: "0;1",
						repeatCount: "indefinite",
						restart: "always",
						values: "1;0"
					})
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "rotate(30 50 50)",
				children: /* @__PURE__ */ _jsx("path", {
					className: "st0",
					d: "M-6.2,25.9h0.7c0.2,0,0.3,0.2,0.3,0.3l0,3.5c0,0.2-0.2,0.3-0.3,0.3h-0.7c-0.2,0-0.3-0.2-0.3-0.3l0-3.5 C-6.6,26.1-6.4,25.9-6.2,25.9z ",
					children: /* @__PURE__ */ _jsx("animate", {
						accumulate: "none",
						additive: "replace",
						attributeName: "opacity",
						begin: "-0.8333333333333334s",
						calcMode: "linear",
						dur: "1s",
						fill: "remove",
						keyTimes: "0;1",
						repeatCount: "indefinite",
						restart: "always",
						values: "1;0"
					})
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "rotate(60 50 50)",
				children: /* @__PURE__ */ _jsx("path", {
					className: "st0",
					d: "M-6.2,55.9h0.7c0.2,0,0.3,0.2,0.3,0.3l0,3.5c0,0.2-0.2,0.3-0.3,0.3h-0.7c-0.2,0-0.3-0.2-0.3-0.3l0-3.5 C-6.6,56-6.4,55.9-6.2,55.9z ",
					children: /* @__PURE__ */ _jsx("animate", {
						accumulate: "none",
						additive: "replace",
						attributeName: "opacity",
						begin: "-0.75s",
						calcMode: "linear",
						dur: "1s",
						fill: "remove",
						keyTimes: "0;1",
						repeatCount: "indefinite",
						restart: "always",
						values: "1;0"
					})
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "rotate(90 50 50)",
				children: /* @__PURE__ */ _jsx("path", {
					className: "st0",
					d: "M8.7,81.8h0.7c0.2,0,0.3,0.2,0.3,0.3v3.5c0,0.2-0.2,0.3-0.3,0.3H8.7c-0.2,0-0.3-0.2-0.3-0.3v-3.5 C8.4,82,8.6,81.8,8.7,81.8z ",
					children: /* @__PURE__ */ _jsx("animate", {
						accumulate: "none",
						additive: "replace",
						attributeName: "opacity",
						begin: "-0.6666666666666666s",
						calcMode: "linear",
						dur: "1s",
						fill: "remove",
						keyTimes: "0;1",
						repeatCount: "indefinite",
						restart: "always",
						values: "1;0"
					})
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "rotate(120 50 50)",
				children: /* @__PURE__ */ _jsx("path", {
					className: "st0",
					d: "M34.7,96.8h0.7c0.2,0,0.3,0.2,0.3,0.3l0,3.5c0,0.2-0.2,0.3-0.3,0.3h-0.7c-0.2,0-0.3-0.2-0.3-0.3v-3.5 C34.3,96.9,34.5,96.8,34.7,96.8z ",
					children: /* @__PURE__ */ _jsx("animate", {
						accumulate: "none",
						additive: "replace",
						attributeName: "opacity",
						begin: "-0.5833333333333334s",
						calcMode: "linear",
						dur: "1s",
						fill: "remove",
						keyTimes: "0;1",
						repeatCount: "indefinite",
						restart: "always",
						values: "1;0"
					})
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "rotate(150 50 50)",
				children: /* @__PURE__ */ _jsx("path", {
					className: "st0",
					d: "M64.6,96.8h0.7c0.2,0,0.3,0.2,0.3,0.3v3.5c0,0.2-0.2,0.3-0.3,0.3h-0.7c-0.2,0-0.3-0.2-0.3-0.3v-3.5 C64.3,96.9,64.4,96.8,64.6,96.8z ",
					children: /* @__PURE__ */ _jsx("animate", {
						accumulate: "none",
						additive: "replace",
						attributeName: "opacity",
						begin: "-0.5s",
						calcMode: "linear",
						dur: "1s",
						fill: "remove",
						keyTimes: "0;1",
						repeatCount: "indefinite",
						restart: "always",
						values: "1;0"
					})
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "rotate(180 50 50)",
				children: /* @__PURE__ */ _jsx("path", {
					className: "st0",
					d: "M90.5,81.8h0.7c0.2,0,0.3,0.2,0.3,0.3v3.5c0,0.2-0.2,0.3-0.3,0.3h-0.7c-0.2,0-0.3-0.2-0.3-0.3v-3.5 C90.2,82,90.4,81.8,90.5,81.8z ",
					children: /* @__PURE__ */ _jsx("animate", {
						accumulate: "none",
						additive: "replace",
						attributeName: "opacity",
						begin: "-0.4166666666666667s",
						calcMode: "linear",
						dur: "1s",
						fill: "remove",
						keyTimes: "0;1",
						repeatCount: "indefinite",
						restart: "always",
						values: "1;0"
					})
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "rotate(210 50 50)",
				children: /* @__PURE__ */ _jsx("path", {
					className: "st0",
					d: "M105.5,55.9h0.7c0.2,0,0.3,0.2,0.3,0.3v3.5c0,0.2-0.2,0.3-0.3,0.3h-0.7c-0.2,0-0.3-0.2-0.3-0.3v-3.5 C105.2,56,105.3,55.9,105.5,55.9z ",
					children: /* @__PURE__ */ _jsx("animate", {
						accumulate: "none",
						additive: "replace",
						attributeName: "opacity",
						begin: "-0.3333333333333333s",
						calcMode: "linear",
						dur: "1s",
						fill: "remove",
						keyTimes: "0;1",
						repeatCount: "indefinite",
						restart: "always",
						values: "1;0"
					})
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "rotate(240 50 50)",
				children: /* @__PURE__ */ _jsx("path", {
					className: "st0",
					d: "M105.5,25.9h0.7c0.2,0,0.3,0.2,0.3,0.3v3.5c0,0.2-0.2,0.3-0.3,0.3h-0.7c-0.2,0-0.3-0.2-0.3-0.3v-3.5 C105.2,26.1,105.3,25.9,105.5,25.9z ",
					children: /* @__PURE__ */ _jsx("animate", {
						accumulate: "none",
						additive: "replace",
						attributeName: "opacity",
						begin: "-0.25s",
						calcMode: "linear",
						dur: "1s",
						fill: "remove",
						keyTimes: "0;1",
						repeatCount: "indefinite",
						restart: "always",
						values: "1;0"
					})
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "rotate(270 50 50)",
				children: /* @__PURE__ */ _jsx("path", {
					className: "st0",
					d: "M90.5,0h0.7c0.2,0,0.3,0.2,0.3,0.3v3.5c0,0.2-0.2,0.3-0.3,0.3h-0.7c-0.2,0-0.3-0.2-0.3-0.3V0.3 C90.2,0.2,90.4,0,90.5,0z ",
					children: /* @__PURE__ */ _jsx("animate", {
						accumulate: "none",
						additive: "replace",
						attributeName: "opacity",
						begin: "-0.16666666666666666s",
						calcMode: "linear",
						dur: "1s",
						fill: "remove",
						keyTimes: "0;1",
						repeatCount: "indefinite",
						restart: "always",
						values: "1;0"
					})
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "rotate(300 50 50)",
				children: /* @__PURE__ */ _jsx("path", {
					className: "st0",
					d: "M64.6-15h0.7c0.2,0,0.3,0.2,0.3,0.3v3.5c0,0.2-0.2,0.3-0.3,0.3h-0.7c-0.2,0-0.3-0.2-0.3-0.3v-3.5 C64.3-14.8,64.4-15,64.6-15z ",
					children: /* @__PURE__ */ _jsx("animate", {
						accumulate: "none",
						additive: "replace",
						attributeName: "opacity",
						begin: "-0.08333333333333333s",
						calcMode: "linear",
						dur: "1s",
						fill: "remove",
						keyTimes: "0;1",
						repeatCount: "indefinite",
						restart: "always",
						values: "1;0"
					})
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "rotate(330 50 50)",
				children: /* @__PURE__ */ _jsx("path", {
					className: "st0",
					d: "M34.7-15h0.7c0.2,0,0.3,0.2,0.3,0.3v3.5c0,0.2-0.2,0.3-0.3,0.3h-0.7c-0.2,0-0.3-0.2-0.3-0.3v-3.5 C34.3-14.8,34.5-15,34.7-15z ",
					children: /* @__PURE__ */ _jsx("animate", {
						accumulate: "none",
						additive: "replace",
						attributeName: "opacity",
						begin: "0s",
						calcMode: "linear",
						dur: "1s",
						fill: "remove",
						keyTimes: "0;1",
						repeatCount: "indefinite",
						restart: "always",
						values: "1;0"
					})
				})
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgSpinnerAnim);
export default ForwardRef;
